import { Trans, useTranslation } from 'react-i18next';
import { get, useFormState } from 'react-hook-form';
import CheckboxGroupField from 'components/forms/checkboxGroupField/CheckboxGroupField';
import { TransLink } from 'components/text/TransLink';

const AllowBookingRequestField = () => {
  const { t } = useTranslation();
  const { dirtyFields, errors } = useFormState();

  const isValidMaximumStay =
    !!get(dirtyFields, 'airbnbSettings.allowBookingRequestAboveMaximumStay') &&
    !get(errors, 'airbnbSettings.allowBookingRequestAboveMaximumStay');
  const isValidBookingLeadTime =
    !!get(
      dirtyFields,
      'airbnbSettings.allowBookingRequestWithinBookingLeadTime',
    ) &&
    !get(errors, 'airbnbSettings.allowBookingRequestWithinBookingLeadTime');
  const isValidBeyondBookingWindow =
    !!get(
      dirtyFields,
      'airbnbSettings.allowBookingRequestBeyondBookingWindow',
    ) && !get(errors, 'airbnbSettings.allowBookingRequestBeyondBookingWindow');

  return (
    <CheckboxGroupField
      name="airbnbSettings.allowBookingRequest"
      label={t('pageProperty.mainSettings.airbnbSettings.allowBookingRequest')}
      colSmInput={7}
      colSmLabel={5}
      hideParentCheckbox
      isValid={
        isValidMaximumStay ||
        isValidBookingLeadTime ||
        isValidBeyondBookingWindow
      }
      rightTooltip={
        <Trans
          i18nKey="pageProperty.mainSettings.airbnbSettings.allowBookingRequestTooltip"
          components={{
            link1: (
              <TransLink
                target="_blank"
                href="https://help.hostfully.com/en/articles/3811657-partially-allow-booking-requests-on-airbnb"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      options={[
        {
          name: 'airbnbSettings.allowBookingRequestAboveMaximumStay',
          label: t('pageProperty.mainSettings.airbnbSettings.aboveMaximumStay'),
        },
        {
          name: 'airbnbSettings.allowBookingRequestWithinBookingLeadTime',
          label: t(
            'pageProperty.mainSettings.airbnbSettings.withinBookingLeadTime',
          ),
        },
        {
          name: 'airbnbSettings.allowBookingRequestBeyondBookingWindow',
          label: t(
            'pageProperty.mainSettings.airbnbSettings.beyondBookingWindow',
          ),
        },
      ]}
    />
  );
};

export default AllowBookingRequestField;
